import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePageES from "./HomePageES";
import HomePage from "./HomePage";
import LoginPage from "./LoginPage";
import DashboardPage from "./DashboardPage";
import AdminLoginPage from "./AdminLoginPage";
import AdminDashboard from "./AdminDashboard";
import QuestionsPage from "./QuestionsPage";
import RefinanceQuestions from "./RefinanceQuestions";
import SelectTransactionPage from "./SelectTransactionPage";
import OfficerDashboard from "./OfficerDashboard";
import OfficerView from "./OfficerView";
import OfficerViewES from "./OfficerViewES";
import QuestionsPageES from "./QuestionsPageES";
import RefinanceQuestionsES from "./RefinanceQuestionsES";
import DashboardPageES from "./DashboardPageES";
import LoginPageES from "./LoginPageES";
import SelectTransactionPageES from "./SelectTransactionPageES";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePageES />} />
        <Route path="/es" element={<HomePageES />} />
        <Route path="/en" element={<HomePage />} />
        <Route path="/es/login" element={<LoginPageES />} />
        <Route path="/en/login" element={<LoginPage />} />
        <Route path="/es/dashboard" element={<DashboardPageES />} />
        <Route path="/en/dashboard" element={<DashboardPage />} />
        <Route path="/admin-login" element={<AdminLoginPage />} />
        <Route path="/admin-dashboard" element={<AdminDashboard />} />
        <Route path="/es/questions" element={<QuestionsPageES />} />
        <Route path="/en/questions" element={<QuestionsPage />} />
        <Route path="/es/refinance" element={<RefinanceQuestionsES />} />
        <Route path="/en/refinance" element={<RefinanceQuestions />} />
        <Route
          path="/es/select-transaction"
          element={<SelectTransactionPageES />}
        />
        <Route
          path="/en/select-transaction"
          element={<SelectTransactionPage />}
        />
        <Route path="/en/officer-dashboard" element={<OfficerDashboard />} />
        <Route path="/en/officer-view" element={<OfficerView />} />
        <Route path="/es/officer-view" element={<OfficerViewES />} />
      </Routes>
    </Router>
  );
}

export default App;
